/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_ItInputs */

const en_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const es_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const de_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const zh_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const ar_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const fr_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const vi_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const sw_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const th_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const bs_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const ja_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const ko_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const pt_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const it_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const sv_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const nl_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const da_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const nb_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const fi_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const pl_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const ru_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const tr_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const hi_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const id_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const ms_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const cs_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const el_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const he_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const af_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

const hu_nav_language_it = /** @type {(inputs: Nav_Language_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

/**
* | output |
* | --- |
* | "Italiano" |
*
* @param {Nav_Language_ItInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_it = /** @type {((inputs?: Nav_Language_ItInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_ItInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_it(inputs)
	if (locale === "de") return de_nav_language_it(inputs)
	if (locale === "zh") return zh_nav_language_it(inputs)
	if (locale === "ar") return ar_nav_language_it(inputs)
	if (locale === "fr") return fr_nav_language_it(inputs)
	if (locale === "vi") return vi_nav_language_it(inputs)
	if (locale === "sw") return sw_nav_language_it(inputs)
	if (locale === "th") return th_nav_language_it(inputs)
	if (locale === "bs") return bs_nav_language_it(inputs)
	if (locale === "ja") return ja_nav_language_it(inputs)
	if (locale === "ko") return ko_nav_language_it(inputs)
	if (locale === "pt") return pt_nav_language_it(inputs)
	if (locale === "it") return it_nav_language_it(inputs)
	if (locale === "sv") return sv_nav_language_it(inputs)
	if (locale === "nl") return nl_nav_language_it(inputs)
	if (locale === "da") return da_nav_language_it(inputs)
	if (locale === "nb") return nb_nav_language_it(inputs)
	if (locale === "fi") return fi_nav_language_it(inputs)
	if (locale === "pl") return pl_nav_language_it(inputs)
	if (locale === "ru") return ru_nav_language_it(inputs)
	if (locale === "tr") return tr_nav_language_it(inputs)
	if (locale === "hi") return hi_nav_language_it(inputs)
	if (locale === "id") return id_nav_language_it(inputs)
	if (locale === "ms") return ms_nav_language_it(inputs)
	if (locale === "cs") return cs_nav_language_it(inputs)
	if (locale === "el") return el_nav_language_it(inputs)
	if (locale === "he") return he_nav_language_it(inputs)
	if (locale === "af") return af_nav_language_it(inputs)
	if (locale === "hu") return hu_nav_language_it(inputs)
	return en_nav_language_it(inputs)
});